import React,{useEffect, useState, useCallback, useRef} from 'react';
import { setHeader } from '../../store/settings/settingsSlice';
import { useDispatch, useSelector } from 'react-redux';
import style from "./withdraw.module.css";
import nigeria_icon from '../../assets/images/nigeria.svg'
import ng_icon from '../../assets/images/ng.svg'
import us_icon from '../../assets/images/us.svg'
import ghana_icon from '../../assets/images/ghanaflag.svg'
import arrow_right from '../../assets/images/arrow-right.svg'
import usd_icon from '../../assets/images/usd.svg'
import walletArrowBg from '../../assets/images/walletArrow.svg'
import spin_circle from '../../assets/images/Loader anim.png'
import successIcon from '../../assets/images/check-mark.svg'
import arrow_left from '../../assets/images/arrow-left.svg'
import bank_icon from '../../assets/images/bank.svg'
import transactionTypeIcon from '../../assets/images/typeIcon.svg'
import moneyIcon from '../../assets/images/moneys.svg'
import narration_icon from '../../assets/images/sms.svg'
import {  Eye,EyeSlash, ArrowDown2, InfoCircle} from "iconsax-react";
import { browserName } from "react-device-detect";
import Modal from '../modal/Modal';
import PinInput from "react-pin-input";
import { getBankAccounts, getCryptoAccounts } from '../../store/settings/settingsActions';
import { fetchWithdrawalFees, fetchWithdrawalSettings, withdrawToBank, getFiatCurrencies, withdrawCrypto, transferToAstro, fetchAstroName, getWalletBalance } from '../../store/wallet/walletActions';
import {
    getKycSettingsById,
    getKycStatusById,
    getUserDailyWithdrawal,
  } from "../../store/KYC/kycAction";
  import { getBanks, getAccountName } from '../../store/settings/settingsActions';
import { ghAccounts, mobileMoney } from '../../components/settings/data'; // You'll need to create this data file
import { clearAllBanks } from '../../store/settings/settingsSlice';
import cogoToast from "cogo-toast";
import Lottie from "lottie-react";
import loader from "../../assets/lottie/loader.json";
import { useLocation, useNavigate } from 'react-router-dom';


const WithdrawWithFiatPage = () => {
    const dispatch = useDispatch();
    const [location, setLocation] = useState("NGN");
    const [visible, setVisible] = useState(true);
    const navigate = useNavigate();
    const walletData = useSelector((state) => state.wallet.data);
    const allAccounts = useSelector((state) => state.settings.allAccounts);
    const fees = useSelector((state) => state.wallet.fees);
    const dailyStat = useSelector((state) => state.userKyc.dailyStat);
    const currentSetting = useSelector((state) => state.userKyc.currentSettings.kycSetting);
    const allCryptoAccounts = useSelector((state) => state.settings.allCryptoAccounts);

    const allBanks = useSelector((state) => state.settings.allBanks);
    const accountDets = useSelector((state) => state.settings.accountDets);
    const isNameLoading = useSelector((state) => state.settings.nameLoading);
    const isAcctLoading = useSelector((state) => state.settings.loading);
    const [isSelectingFromFavorites, setIsSelectingFromFavorites] = useState(false);

    const [difference, setDifference] = useState(0);
    const [dailyVal, setDailyVal] = useState(0);
    const [dailyWithdrawal, setDailyWithdrawal] = useState(0);
    const [multiplier, setMultiplier] = useState(0);
    const [cryptoDifference, setCryptoDifference] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const debounceRef = useRef(null); // ✅ useRef to persist timeout
    const [bankCode, setBankCode] = useState("");
    const [bankName, setBankName] = useState("");
    const [accountType, setAccountType] = useState("");
    const [openAccountType, setOpenAccountType] = useState(false);
    const [openBankSelect, setOpenBankSelect] = useState(false);
    const [bankLoading, setBankLoading] = useState(false);
    const [nameLoading, setNameLoading] = useState(false);

    const [showFavoritesDropdown, setShowFavoritesDropdown] = useState(false);

    const locationHook = useLocation();
    useEffect(() => {
    const params = new URLSearchParams(locationHook.search);
    const currency = params.get("currency");
    if (currency) setLocation(currency);
    }, [locationHook.search]);

    const [isTransferModal, setTransferModal] = useState(false);
    const [isTransferBankModal, setTransferBankModal] = useState(false);
    const [putPass, setPutPass] = useState(false);
    const [isTagPinModal, setTagPinModal] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isSuccessModal, setSuccessModal] = useState(false);
    const [isInitiated, setIsInitiated] = useState(false);
    const [account, setAccount] = useState("");
    const [amount, setAmount] = useState(0);
    const [accountNumber, setAccountNumber] = useState("");
    const [accountName, setAccountName] = useState("");
    const [userNotFound, setUserNotFound] = useState(false);
    const [prevAstroTag, setPrevAstroTag] = useState("");
    const [narration, setNarration] = useState("");
    const [astroTag, setAstroTag] = useState("");
    const [openAccount, setOpenAccount] = useState(false);
    const [bankAcctId, setBankAcctId] = useState("");
    const [disabled, setDisabled] = useState(true);
    const [sortedAccounts, setSortedAccounts] = useState([]);
    const [trPin, setTrPin] = useState(""); 
    let ele = useRef();

    const getAccountTypes = () => {
    if (location === "NGN") {
        return [{ id: 1, title: "ng-account" }];
    } else if (location === "GHS") {
        return [
        { id: 2, title: "gh-mobile" },
        { id: 6, title: "gh-account" },
        ];
    }
    return [];
    };
    
    const currencyIcons = {
        NGN: nigeria_icon,
        GHS: ghana_icon,
        USD: usd_icon,
        // Add more if needed
    };

    // Add these handlers
    const handleAccountType = (title) => {
        setOpenAccountType(false);
        setAccountType(title);
        setBankName("");
        setBankCode("");
        setAccountNumber("");
        setAccountName("");

        if (title === "ng-account") {
            dispatch(getBanks({ title: "NG" }));
        } else if (title === "gh-account" || title === "gh-mobile") {
            dispatch(clearAllBanks());
      }
    };

    const handleBankSelect = (bankName, code) => {
    setOpenBankSelect(false);
    setBankName(bankName);
    setBankCode(code);
    setAccountNumber("");
    setAccountName("");
    };

    const handleAccountNumberChange = (e) => {
    setAccountNumber(e.target.value);
    setAccountName("");
    setIsSelectingFromFavorites(false); // Reset favorites selection
    };

    // Add useEffects for loading states and account name fetching
    useEffect(() => {
    if (isAcctLoading) {
        setBankLoading(true);
    } else {
        setBankLoading(false);
    }

    if (isNameLoading) {
        setNameLoading(true);
    } else {
        setNameLoading(false);
    }
    }, [isAcctLoading, isNameLoading]);


   useEffect(() => {
        if (accountNumber.length === 10 && 
            bankCode && 
            (location === "NGN" || accountType === "ng-account") && 
            !isSelectingFromFavorites) { // ← Add this condition
            dispatch(getAccountName({ bankCode, accountNumber }));
        }
   }, [accountNumber, bankCode, dispatch, location, accountType, isSelectingFromFavorites]);

    useEffect(() => {
    if (accountDets?.accountName) {
        setAccountName(accountDets.accountName);
    }
    }, [accountDets]);

    // Add click outside handlers for the new dropdowns
    useEffect(() => {
    let handler = (e) => {
        if (e.target.id !== "accountType") {
        setOpenAccountType(false);
        } else if (e.target.id === "accountType") {
        setOpenAccountType(prev => !prev);
        }
        if (e.target.id === "accountTypeDrop") {
        setOpenAccountType(true);
        }
    };
    document.addEventListener("mousedown", handler);
    return () => {
        document.removeEventListener("mousedown", handler);
    };
    }, []);

    useEffect(() => {
    let handler = (e) => {
        if (e.target.id !== "bankSelect") {
        setOpenBankSelect(false);
        } else if (e.target.id === "bankSelect") {
        setOpenBankSelect(prev => !prev);
        }
        if (e.target.id === "bankSelectDrop") {
        setOpenBankSelect(true);
        }
    };
    document.addEventListener("mousedown", handler);
    return () => {
        document.removeEventListener("mousedown", handler);
    };
    }, []);

      const handleTabChange = (code) => {
        setLocation(code);
        const params = new URLSearchParams(locationHook.search);
        params.set("currency", code);
        navigate({ search: params.toString() }, { replace: true });
     };


    useEffect(() => {
        setDailyVal(dailyStat.userwithdrawndaily ? dailyStat.userwithdrawndaily : 0);
        setDailyWithdrawal(currentSetting ? currentSetting.daily_withdrawer_limit : 0);
    }, [
        multiplier,
        dailyStat,
        currentSetting,
    ]);

    useEffect(() => {
        setDifference(
        multiplier > 0
            ? dailyWithdrawal * parseFloat(multiplier) -
                dailyVal * parseFloat(multiplier)
            : 0
        );
    }, [multiplier, dailyWithdrawal, dailyVal]);

      useEffect(() => {
        setCryptoDifference(multiplier > 0 ? dailyWithdrawal - dailyVal : 0);
      }, [multiplier, dailyWithdrawal, dailyVal]);

      useEffect(() => {
        dispatch(getFiatCurrencies());
        dispatch(getCryptoAccounts());
        dispatch(fetchWithdrawalSettings());
        dispatch(getUserDailyWithdrawal());
        dispatch(getKycStatusById());
        dispatch(getKycSettingsById());
      }, [dispatch]);

    const handleSelectFromFavorites = (account) => {
          // Set flag to prevent API call
         setIsSelectingFromFavorites(true);

        // Pre-fill form with selected favorite account data
        const details = account.details || account;
        
        setAccountType(details.type?.value || details.type || account.type);
        setBankName(details.bank_name || account.bank_name);
        setBankCode(details.bank_code || account.bank_code);
        setAccountNumber(details.account_number || account.account_number);
        setAccountName(details.account_name || account.account_name);
        setBankAcctId(account.id);

        // Reset flag after state updates
      setTimeout(() => setIsSelectingFromFavorites(false), 100);
    
    };
    

    const handleSortAccounts = useCallback(() => {
        let newSort = [];
      
        if (location === "NGN" && allAccounts.bankAccounts?.length) {
          newSort = allAccounts.bankAccounts.filter((item) =>
            item.type === "ng-account" || item.type?.value === "ng-account"
          );
        } else if (location === "GHS" && allAccounts.bankAccounts?.length) {
          newSort = allAccounts.bankAccounts.filter((item) =>
            item.type === "gh-account" ||
            item.type === "gh-mobile" ||
            item.type?.value === "gh-account" ||
            item.type?.value === "gh-mobile"
          );
        } else if (location === "USD") {
          newSort = allCryptoAccounts.cryptotAccounts || [];
        }
      
        setSortedAccounts(newSort);
      }, [location, allAccounts.bankAccounts, allCryptoAccounts.cryptotAccounts]);
      
      const toggleAccount = () => {
        setOpenAccount((prevAccount) => {
          if (prevAccount === false) {
            return true;
          } else if (prevAccount === true) {
            return false;
          }
        });
      };
    
      const toggleBankTransfer = () =>{
        setTransferBankModal(true)
        setAccountType("")
        setAccount("")
        setBankName("")
        setBankCode("")
        setAccountNumber("")
        setAmount(0)
        setNarration("")
        setBankAcctId("")
        setIsInitiated(false)
        setPutPass(false)
        dispatch(clearAllBanks());
      }

      const toggleAstroBankTransfer = () =>{
        setTransferModal(true)
        setAstroTag("")
        setAmount(0)
        setNarration("")
        setIsInitiated(false)
        setUserNotFound(false);
        setPutPass(false)
      }

    const handleTransfer = () =>{
        setTransferModal(false)
        setTagPinModal(true)
        setTrPin("")
    }

    const handleTransferToBank = () =>{
         setTransferBankModal(false)
         setPutPass(true)
         setTrPin("")
    }

     const withdrawHandler = () => {
        // Find fiat wallet ID
        let fiatWalletId = walletData.fiatWallets.find((item) => item.Currency.code === location).id;

        if (location === "USD") {
            if (amount > cryptoDifference) {
            cogoToast.error(
                "The amount you want to withdraw has EXCEEDED your daily limit, please go to settings to upgrade"
            );
            } else {
            setIsOpen(true);
            dispatch(
                withdrawCrypto({
                bankAcctId,
                fiatWalletId,
                trPin,
                amount,
                })
            ).then((res) => {
                if (res?.type === "withdrawCrypto/fulfilled") {
                setIsOpen(false);
                setSuccessModal(true);
                setIsInitiated(false);
                setTrPin("");
                setPutPass(false);
                ele.clear();
                } else if (res?.type === "withdrawCrypto/rejected") {
                setIsOpen(false);
                setTrPin("");
                setPutPass(false);
                ele.clear();
                }
            });
            }
        } else {
            if (amount > difference) {
            cogoToast.error(
                "The amount you want to withdraw has EXCEEDED your daily limit, please go to settings to upgrade"
            );
            } else {
            setIsOpen(true);
            
            // New payload structure
            const withdrawalPayload = {
                accountName: accountName,
                accountNumber: accountNumber,
                bankCode: bankCode,
                bankName: bankName,
                type: location === "NGN" ? "ng-account" : accountType,
                fiatWalletId: fiatWalletId,
                trPin: trPin,
                amount: parseFloat(amount)
            };

            dispatch(withdrawToBank(withdrawalPayload)).then((res) => {
                if (res?.type === "withdrawToBank/fulfilled") {
                setIsOpen(false);
                setSuccessModal(true);
                setIsInitiated(false);
                dispatch(getWalletBalance());
                setTrPin("");
                setPutPass(false);
                ele.clear();
                } else if (res?.type === "withdrawToBank/rejected") {
                setIsOpen(false);
                setTrPin("");
                setPutPass(false);
                ele.clear();
                }
            });
            }
        }

        // Reset form
        ele.clear();
        setPutPass(false);
        setTrPin("");
        setAccountName("");
        setAccountNumber("");
        setBankName("");
        setBankCode("");
        setAccountType("");
        setAmount(0);
    };




  const getAdaptiveDelay = useCallback((prev, current) => {

     let TYPING_SPEED_DELAY = {
        fast: 800,
        moderate: 500,
        slow: 300,
      };

    const diff = current.length - prev.length;
    const typingSpeed = Math.abs(diff);
  
    if (typingSpeed > 3) return TYPING_SPEED_DELAY.fast;
    if (typingSpeed > 1) return TYPING_SPEED_DELAY.moderate;
    return TYPING_SPEED_DELAY.slow;
  }, []);


 const fetchAstroAccountName = useCallback(async (tag) => {
    setIsLoading(true);
    setUserNotFound(false); // reset before new fetch
    dispatch(fetchAstroName({ name: tag })).then((res) => {
      if (res?.type === "fetchAstroName/fulfilled") {
        setIsLoading(false);
        setAccountName(`${res.payload.data.data.firstname} ${res.payload.data.data.lastname}`)
      } else if (res?.type === "fetchAstroName/rejected") {
        setIsLoading(false);
        setAccountName("")
        setUserNotFound(true);
      }
    });
  }, [dispatch]);


  useEffect(() => {
    if (!astroTag) {
      setAccountName("");
      setUserNotFound(false);
      return;
    }
  
    const delay = getAdaptiveDelay(prevAstroTag, astroTag);
    setPrevAstroTag(astroTag);
  
    if (debounceRef.current) clearTimeout(debounceRef.current);
  
    debounceRef.current = setTimeout(() => {
      fetchAstroAccountName(astroTag);
    }, delay);
  
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [astroTag, fetchAstroAccountName, getAdaptiveDelay, prevAstroTag]);



   const handleInitiateTransfer = () =>{
    let currencyId = walletData?.fiatWallets.find((item) => item.Currency.code === location).Currency.id

     setIsOpen(true)
     dispatch(
        transferToAstro({
         currencyId,
          username: astroTag,
          trPin,
          amount,
        })
      ).then((res)=>{
        if(res?.type === "transferToAstro/fulfilled"){
            setIsOpen(false)
            setSuccessModal(true)
            setIsInitiated(false)
            setAccountName("")
            setAstroTag("")
            setAmount(0)
            setNarration("")
            setUserNotFound(false);
            dispatch(getWalletBalance());
        }
        else if(res?.type === "transferToAstro/rejected"){
            setIsOpen(false)
        }
      });

     ele.clear();
     setTagPinModal(false);
     setTrPin("");
   }


    useEffect(() => {
        handleSortAccounts();
        setAccount("");
     }, [location, handleSortAccounts]);

    useEffect(() => {
        if (trPin !== "" && trPin.length === 5) {
            setDisabled(false);
        } else {
        setDisabled(true);
        }
    }, [trPin]);

    // handle withdrawal fees
    useEffect(()=>{
        if(location === "NGN"){
           let withdrawer_rate = walletData?.fiatWallets?.find((item) => item.Currency.code === location).Currency.withdrawer_rate
            setMultiplier(withdrawer_rate)
            dispatch(fetchWithdrawalFees({
                currency: 'naira'
            }))
        }
        if(location === "GHS"){
        dispatch(fetchWithdrawalFees({
            currency: 'ghana'
        }))
        }
    },[dispatch, location, walletData])

    // HANDLE ACCOUNT CLOSE ON CLICK OUT
    useEffect(() => {
        let handler = (e) => {
        if (e.target.id !== "account") {
            setOpenAccount(false);
        } else if (e.target.id === "account") {
            toggleAccount();
        }
        if (e.target.id === "accountDrop") {
            setOpenAccount(true);
        }
        // console.log(currRef.current.name)
        };
        document.addEventListener("mousedown", handler);
    
        return () => {
        document.removeEventListener("mousedown", handler);
        };
    }, []);

    // Replace the existing favorites useEffect with this:
        useEffect(() => {
            let handler = (e) => {
                // Close dropdown when clicking outside
                if (!e.target.closest('[style*="position: relative"]') && 
                    !e.target.textContent?.includes('Select from my Favorites') && 
                    !e.target.textContent?.includes('Hide Favorites')) {
                    setShowFavoritesDropdown(false);
                }
            };
            document.addEventListener("mousedown", handler);
            return () => {
                document.removeEventListener("mousedown", handler);
            };
        }, []);

        // Update the existing useEffect for loading favorites
        useEffect(() => {
            if (showFavoritesDropdown) {
                handleSortAccounts();
            }
        }, [showFavoritesDropdown, handleSortAccounts]);


    useEffect(() => {
        dispatch(setHeader("Withdraw"));
        dispatch(getBankAccounts());
        dispatch(getWalletBalance());
    }, [dispatch]);


    
    return ( 
        <>

         {/* ===== Withdraw To AstroTag MODAL */}
        <Modal title='Withdraw To AstroTag'  minWidth='40%' canClose modalOpen={isTransferModal} setModalOpen={setTransferModal}>

            {!isInitiated
            ?
            <div style={{marginTop: '25px'}}>


                {
                    location === "NGN"
                  ? 
                    <div className={style.labelPut}>
                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                              <label htmlFor="wallet">From Wallet </label>
                            <p style={{margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14}}>Bal: ₦{walletData?.fiatWallets?.find(wallet => location.includes(wallet.Currency.code)).balance}</p>
                            </div>
                        <div className={style.payoutDiv}>
                            <img src={ng_icon} alt="nigeria icon" width={24} height={24} />
                            <p>NGN</p>
                        </div>
                    </div>
                        :
                    location === "GHS"
                    ?
                    <div className={style.labelPut}>
                         <div style={{display: 'flex', justifyContent: 'space-between'}}>
                              <label htmlFor="wallet">From Wallet </label>
                            <p style={{margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14}}>Bal: ₵{walletData?.fiatWallets?.find(wallet => location.includes(wallet.Currency.code)).balance}</p>
                            </div>
                        <div className={style.payoutDiv}>
                            <img src={ghana_icon} alt="nigeria icon" width={24} height={24} />
                            <p>GHS</p>
                        </div>
                    </div>
                    :
                    <div className={style.labelPut}>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                              <label htmlFor="wallet">From Wallet </label>
                            <p style={{margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14}}>Bal: ${walletData?.fiatWallets?.find(wallet => location.includes(wallet.Currency.code)).balance}</p>
                            </div>
                    <div className={style.payoutDiv}>
                        <img src={us_icon} alt="nigeria icon" width={24} height={24} />
                        <p>USD</p>
                    </div>
                   </div>
                    }

                <div className={style.labelPut}>
                    <label htmlFor="amount">Amount<span style={{color:'#FF0000'}}>*</span></label>
                    <div className={style.input}>
                    <input
                        type="text"
                        name="amount"
                        placeholder="Enter Amount"
                        value={amount}
                        onChange={(e) => {
                            setAmount(e.target.value < 0 ? 0 : e.target.value);
                        }}
                    />
                    </div>
                </div>

                <div className={style.labelPut}>
                    <label htmlFor="astroTag">AstroTag<span style={{color:'#FF0000'}}>*</span></label>
                    <div className={style.input}>
                        <input
                            type="text"
                            name="astroTag"
                            placeholder="Enter astro username"
                            value={astroTag}
                            onChange={(e) => setAstroTag(e.target.value)}
                        />
                    </div>
                    {userNotFound && (
                      <div className={style.info_div}>
                          <InfoCircle size="20" variant="Bold" color="#F40000" />
                        <p style={{margin: '0px', color: '#F40000'}}>User not found. Please check the AstroTag.
                        </p>
                    </div>
                    )}
                </div>


                <div className={style.labelPut}>
                    <label htmlFor="accountName">Astro Account Name</label>
                    <div className={style.input}>
                        <input
                            type="text"
                            name="accountName"
                            placeholder="Astro Account Name"
                            disabled
                            value={accountName}
                        />
                     {isLoading && (
                        <div className={style.lottieWrapDrop}>
                        <Lottie
                            style={{
                            width: "70px",
                            height: "70px",
                            color: "#fff",
                            padding: "0px",
                            margin: "0px",
                            }}
                            animationData={loader}
                            loop={true}
                        />
                        </div>
                      )}
                    </div>
                </div>

                <div className={style.labelPut}>
                    <label htmlFor="narration">Narration</label>
                    <div className={style.input}>
                    <input
                        type="text"
                        name="narration"
                        placeholder="Narration"
                        value={narration}
                        onChange={(e) => setNarration(e.target.value)}
                    />
                    </div>
                </div>


                            
                <button disabled={!amount || !astroTag || !accountName || isLoading} onClick={() => setIsInitiated(true)} style={{marginTop: '20px'}} className={style.save}>
                    Proceed
                    </button>
                 

            </div>
            :
            <div style={{marginTop: '20px'}}>

                <div  onClick={() => setIsInitiated(false)} style={{width: '20px', height: '20px', background: '#40196d1a', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'}}>
                    <img src={arrow_left} alt="arrow left" />
                </div>

                <div style={{background: '#F5F3F7', marginTop: '20px', borderRadius: '20px', padding: '25px 25px'}}>
                    <p style={{color: '#212121', fontWeight: '400', textAlign: 'left', fontSize: 14, marginBottom: 0}}>Please check transaction details</p>

                    {
                    location === "NGN"
                         ? 
                        <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <img src={ng_icon} alt='ng icon' />
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>From Wallet</h6>
                                <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>NGN Wallet</p>
                            </div>
                        </div>
                        :
                location === "GHS"
                              ?
                        <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                        <div>
                            <img src={ghana_icon} alt='ng icon' />
                        </div>
                        <div>
                            <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>From Wallet</h6>
                            <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>GHS Wallet</p>
                        </div>
                    </div>
                    :
                    <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                    <div>
                        <img src={us_icon} alt='ng icon' />
                    </div>
                    <div>
                        <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>From Wallet</h6>
                        <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>USD Wallet</p>
                    </div>
                </div>
                    }

                    <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                        <div>
                            <img src={transactionTypeIcon} alt='transactionTypeIcon' />
                        </div>
                        <div>
                            <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Transfer Type</h6>
                            <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>To Astro</p>
                        </div>
                    </div>

                    <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                        <div>
                            <img src={transactionTypeIcon} alt='transactionTypeIcon' />
                        </div>
                        <div>
                            <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>AstroTag</h6>
                            <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>{astroTag ? astroTag: ''}</p>
                        </div>
                    </div>

                    <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <img src={narration_icon} alt='narration_icon' />
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Narration</h6>
                                <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>{narration ? narration: 'N/A'}</p>
                            </div>
                        </div>



                    <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                        <div>
                            <img src={moneyIcon} alt='moneyIcon' />
                        </div>
                        <div>
                            <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Amount</h6>
                            <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>{location} {amount}</p>
                        </div>
                    </div>

                    <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                        <div>
                        <img src={moneyIcon} alt='moneyIcon' />
                        </div>
                        <div>
                            <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Withdrawal Fee</h6>
                            <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>{location} 0.00</p>
                        </div>
                    </div>

                   
                </div>
            
                <button onClick={handleTransfer} style={{marginTop: '30px'}} className={style.save}>
                Proceed
                </button>

            </div>
            }
        </Modal>

         {/* ===== Withdraw To Bank MODAL */}
         <Modal title='Withdraw To Bank'  minWidth='40%' canClose modalOpen={isTransferBankModal} setModalOpen={setTransferBankModal}>
                {!isInitiated
                ?
                <div style={{marginTop: '25px'}}>


                  {
                    location === "NGN"
                  ? 
                    <div className={style.labelPut}>
                          <div style={{display: 'flex', justifyContent: 'space-between'}}>
                              <label htmlFor="wallet">From Wallet </label>
                            <p style={{margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14}}>Bal: ₦{walletData?.fiatWallets?.find(wallet => location.includes(wallet.Currency.code)).balance}</p>
                            </div>
                        <div className={style.payoutDiv}>
                            <img src={ng_icon} alt="nigeria icon" width={24} height={24} />
                            <p>NGN</p>
                        </div>
                    </div>
                        :
                    location === "GHS"
                    ?
                    <div className={style.labelPut}>
                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                              <label htmlFor="wallet">From Wallet </label>
                            <p style={{margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14}}>Bal: ₵{walletData?.fiatWallets?.find(wallet => location.includes(wallet.Currency.code)).balance}</p>
                            </div>
                        <div className={style.payoutDiv}>
                            <img src={ghana_icon} alt="nigeria icon" width={24} height={24} />
                            <p>GHS</p>
                        </div>
                    </div>
                    :
                    <div className={style.labelPut}>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                              <label htmlFor="wallet">From Wallet </label>
                            <p style={{margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14}}>Bal: ${walletData?.fiatWallets?.find(wallet => location.includes(wallet.Currency.code)).balance}</p>
                            </div>
                    <div className={style.payoutDiv}>
                        <img src={us_icon} alt="nigeria icon" width={24} height={24} />
                        <p>USD</p>
                    </div>
                   </div>
                    }

                   {/* Account Type Selection - Only show for NGN and GHS */}
                    {(location === "NGN" || location === "GHS") && (
                    <div className={style.labelPut}>
                        <label htmlFor="accountType">Account Type<span style={{color:'#FF0000'}}>*</span></label>
                        <div className={style.select} style={{marginTop: '10px'}}>
                        <div 
                            id="accountType"
                            name="accountType" 
                            className={style.selectInput}
                        >
                            <input
                            type="text"
                            disabled={browserName === "Firefox" ? false : true}
                            value={accountType}
                            placeholder="Select Account Type"
                            style={{pointerEvents: "none"}}
                            />
                            <ArrowDown2
                            style={{
                                transform: openAccountType ? "translateY(-50%) rotate(-540deg)" : "translateY(-50%) rotate(0deg)",
                                pointerEvents: "none",
                            }}
                            className={style.dropDown}
                            size="20"
                            color="#909090"
                            variant="Bold"
                            />
                        </div>
                        <div
                            style={{
                            height: openAccountType ? "fit-content" : "0px",
                            maxHeight: 'fit-content',
                            }}
                            className={style.option}
                        >
                            {getAccountTypes().map((type, index) => (
                            <p
                                id="accountTypeDrop"
                                key={type.id}
                                onClick={() => handleAccountType(type.title)}
                                style={{
                                borderBottom: `${index !== getAccountTypes().length - 1 ? '1px #90909042 solid': ''}`
                                }}
                            >
                                {type.title}
                            </p>
                            ))}
                        </div>
                        </div>
                    </div>
                    )}

               
                {/* Bank Selection */}
            <div className={style.labelPut}>
                <label htmlFor="bank">Select Bank<span style={{color:'#FF0000'}}>*</span></label>
                <div className={style.select} style={{marginTop: '10px'}}>
                    <div 
                    id="bankSelect"
                    name="bank" 
                    className={style.selectInput}
                    >
                    <input
                        type="text"
                        disabled={browserName === "Firefox" ? false : true}
                        value={bankName}
                        placeholder="Select Bank"
                        style={{pointerEvents: "none"}}
                    />
                    {bankLoading ? (
                        <div className={style.lottieWrapDrop}>
                        <Lottie
                            style={{
                            width: "70px",
                            height: "70px",
                            color: "#fff",
                            padding: "0px",
                            margin: "0px",
                            }}
                            animationData={loader}
                            loop={true}
                        />
                        </div>
                    ) : (
                        <ArrowDown2
                        style={{
                            transform: openBankSelect ? "translateY(-50%) rotate(-540deg)" : "translateY(-50%) rotate(0deg)",
                            pointerEvents: "none",
                        }}
                        className={style.dropDown}
                        size="20"
                        color="#909090"
                        variant="Bold"
                        />
                    )}
                    </div>
                    <div
                    style={{
                            height: openBankSelect ? "fit-content" : "0px",
                            maxHeight: openBankSelect ? "200px" : "0px",
                            overflowY: openBankSelect ? "auto" : "hidden",
                            transition: "all 0.3s ease"
                        }}
                    className={style.option}
                    >
                    {/* Nigerian Banks */}
                    {(location === "NGN" || accountType === "ng-account") && allBanks?.length > 0 ? (
                        allBanks.map((bank, index) => (
                        <p
                            id="bankSelectDrop"
                            key={bank.id}
                            onClick={() => handleBankSelect(bank.name, bank.code)}
                            style={{
                            borderBottom: `${index !== allBanks.length - 1 ? '1px #90909042 solid': ''}`,
                            padding: '12px 16px',
                            cursor: 'pointer',
                            margin: 0
                            }}
                        >
                            {bank.name}
                        </p>
                        ))
                    ) : (location === "NGN" || accountType === "ng-account") && (
                        <p style={{ padding: '12px 16px', margin: 0, color: '#909090' }}>
                        No banks available
                        </p>
                    )}

                    {/* Ghana Banks */}
                    {accountType === "gh-account" && ghAccounts?.length > 0 ? (
                        ghAccounts.map((bank, index) => (
                        <p
                            id="bankSelectDrop"
                            key={bank.id}
                            onClick={() => handleBankSelect(bank.name, bank.code)}
                            style={{
                            borderBottom: `${index !== ghAccounts.length - 1 ? '1px #90909042 solid': ''}`
                            }}
                        >
                            {bank.name}
                        </p>
                        ))
                    ) : accountType === "gh-account" && (
                        <p style={{ padding: '12px 16px', margin: 0, color: '#909090' }}>
                        No banks available
                        </p>
                    )}

                    {/* Ghana Mobile Money */}
                    {accountType === "gh-mobile" && mobileMoney?.length > 0 ? (
                        mobileMoney.map((provider, index) => (
                        <p
                            id="bankSelectDrop"
                            key={provider.id}
                            onClick={() => handleBankSelect(provider.name, provider.code)}
                            style={{
                            borderBottom: `${index !== mobileMoney.length - 1 ? '1px #90909042 solid': ''}`,
                            padding: '12px 16px',
                            cursor: 'pointer',
                            margin: 0
                            }}
                        >
                            {provider.name}
                        </p>
                        ))
                    ): accountType === "gh-mobile" && (
                    <p style={{ padding: '12px 16px', margin: 0, color: '#909090' }}>
                    No mobile money providers available
                    </p>
                )}

                    {/* USD Accounts */}
                    {location === "USD" && sortedAccounts?.length > 0 ? (
                        sortedAccounts.map((account, index) => (
                        <p
                            id="bankSelectDrop"
                            key={account.id}
                            onClick={() => {
                            setBankName(`${account.coin_type} wallet - ${account.wallet_address}`);
                            setBankAcctId(account.id);
                            }}
                            style={{
                            borderBottom: `${index !== sortedAccounts.length - 1 ? '1px #90909042 solid': ''}`,
                            padding: '12px 16px',
                            cursor: 'pointer',
                            margin: 0
                            }}
                        >
                            {account.wallet_address ? (
                            `${account.coin_type} wallet - ${account.wallet_address}`
                            ) : (
                            `${account.details?.account_name} - ${account.details?.bank_name}`
                            )}
                        </p>
                        ))
                    ) : location === "USD" && (
                        <p style={{ padding: '12px 16px', margin: 0, color: '#909090' }}>
                        No accounts available
                        </p>
                    )}
                    </div>
                </div>
                
                {/* Favorites Section - Simple and Clean */}
                <div style={{position: 'relative', width: '100%'}}>
                    <p 
                        onClick={() => setShowFavoritesDropdown(!showFavoritesDropdown)}
                        style={{
                            color: '#40196D', 
                            textDecoration: 'underline', 
                            textAlign: 'right', 
                            fontSize: 12, 
                            margin: '8px 0 0 0', 
                            cursor: 'pointer'
                        }}
                    >
                        {showFavoritesDropdown ? 'Hide Favorites' : 'Select from my Favorites'}
                    </p>
                    
                    {/* Simple Favorites Dropdown */}
                    {showFavoritesDropdown && (
                        <div 
                            style={{
                                position: 'absolute',
                                top: '100%',
                                left: 0,
                                right: 0,
                                background: '#ffffff',
                                border: '1px solid #e8e8e8',
                                borderRadius: '8px',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                zIndex: 1000,
                                maxHeight: '200px',
                                overflowY: 'auto',
                                marginTop: '4px'
                            }}
                        >
                            {sortedAccounts.length > 0 ? (
                                <>
                                    {/* Clear Selection Option */}
                                    <p
                                        onClick={() => {
                                            setAccountType("");
                                            setBankName("");
                                            setBankCode("");
                                            setAccountNumber("");
                                            setAccountName("");
                                            setBankAcctId("");
                                            setShowFavoritesDropdown(false);
                                            setIsSelectingFromFavorites(false);
                                        }}
                                        style={{
                                            borderBottom: '2px solid #f0f0f0',
                                            padding: '12px 16px',
                                            cursor: 'pointer',
                                            margin: 0,
                                            fontSize: '12px',
                                            color: '#ff4757',
                                            fontWeight: '600',
                                            fontStyle: 'italic'
                                        }}
                                    >
                                        ✕ Clear Selection (Enter manually)
                                    </p>
                                    
                                    {/* Saved Accounts */}
                                    {sortedAccounts.map((account, index) => (
                                        <p
                                            key={account.id}
                                            onClick={() => {
                                                handleSelectFromFavorites(account);
                                                setShowFavoritesDropdown(false);
                                            }}
                                            style={{
                                                borderBottom: `${index !== sortedAccounts.length - 1 ? '1px #90909042 solid': ''}`,
                                                padding: '12px 16px',
                                                cursor: 'pointer',
                                                margin: 0,
                                                fontSize: '13px',
                                                lineHeight: '1.6'
                                            }}
                                            onMouseOver={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                            onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
                                        >
                                            <strong>{(account.details?.bank_name || account.bank_name)}</strong> - {(account.details?.account_number || account.account_number)}
                                            <br />
                                            <span style={{fontSize: '11px', color: '#666'}}>
                                                {account.details?.account_name || account.account_name}
                                            </span>
                                        </p>
                                    ))}
                                </>
                            ) : (
                                <p style={{ padding: '12px 16px', margin: 0, color: '#909090', textAlign: 'center' }}>
                                    No saved accounts found
                                </p>
                            )}
                        </div>
                    )}
                </div>
            </div>
    
                  {/* Account Number Input */}
                    {(location === "NGN" || location === "GHS") && (
                    <div className={style.labelPut}>
                    <label htmlFor="accountNumber">Account Number<span style={{color:'#FF0000'}}>*</span></label>
                    <div className={style.input}>
                        <input
                        type="text"
                        name="accountNumber"
                        placeholder="Enter account number"
                        value={accountNumber}
                        onChange={handleAccountNumberChange}
                        disabled={nameLoading}
                        />
                    </div>
                    </div>
                    )}


                    {/* Account Name Input */}
                      {(location === "NGN" || location === "GHS") && (
                    <div className={style.labelPut}>
                    <label htmlFor="accountName">Account Name</label>
                    <div className={style.input}>
                        <input
                        type="text"
                        name="accountName"
                        placeholder="Account Name"
                        value={accountName}
                        onChange={(e) => setAccountName(e.target.value)}
                        disabled={location === "NGN" || accountType === "ng-account"}
                        />
                        {nameLoading && (
                        <div className={style.lottieWrapDrop}>
                            <Lottie
                            style={{
                                width: "70px",
                                height: "70px",
                                color: "#fff",
                                padding: "0px",
                                margin: "0px",
                            }}
                            animationData={loader}
                            loop={true}
                            />
                        </div>
                        )}
                    </div>
                    </div>
                    )}


                    <div className={style.labelPut}>
                        <label htmlFor="amount">Amount<span style={{color:'#FF0000'}}>*</span></label>
                        <div className={style.input}>
                        <input
                            type="number"
                            name="amount"
                            placeholder="Enter Amount"
                            value={amount}
                            onChange={(e) => {
                                setAmount(e.target.value < 0 ? 0 : e.target.value);
                              }}
                        />
                        </div>
                    </div>

                    <div className={style.labelPut}>
                        <label htmlFor="narration">Narration</label>
                        <div className={style.input}>
                        <input
                            type="text"
                            name="narration"
                            placeholder="Narration"
                            value={narration}
                            onChange={(e) => setNarration(e.target.value)}
                        />
                        </div>
                    </div>
                    
                   <button 
                    disabled={
                        !amount || 
                        !bankName || 
                        (location !== "USD" && (!accountNumber || !accountName)) ||
                         ((location === "NGN" || location === "GHS") && !accountType)
                    } 
                    onClick={() => setIsInitiated(true)} 
                    style={{marginTop: '20px'}} 
                    className={style.save}
                    >
                    Proceed
                    </button>
                      

                </div>
                :
                <div style={{marginTop: '20px'}}>

                    <div  onClick={() => setIsInitiated(false)} style={{width: '20px', height: '20px', background: '#40196d1a', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'}}>
                        <img src={arrow_left} alt="arrow left" />
                    </div>

                    <div style={{background: '#F5F3F7', marginTop: '20px', borderRadius: '20px', padding: '25px 25px'}}>
                        <p style={{color: '#212121', fontWeight: '400', textAlign: 'left', fontSize: 14, marginBottom: 0}}>Please check transaction details</p>

                        {
                    location === "NGN"
                         ? 
                        <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <img src={ng_icon} alt='ng icon' />
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>From Wallet</h6>
                                <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>NGN Wallet</p>
                            </div>
                        </div>
                        :
                location === "GHS"
                              ?
                        <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                        <div>
                            <img src={ghana_icon} alt='ng icon' />
                        </div>
                        <div>
                            <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>From Wallet</h6>
                            <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>GHS Wallet</p>
                        </div>
                    </div>
                    :
                    <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                    <div>
                        <img src={us_icon} alt='ng icon' />
                    </div>
                    <div>
                        <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>From Wallet</h6>
                        <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>USD Wallet</p>
                    </div>
                </div>
                    }


                {/* Account Type - Show for NGN and GHS */}
                    {(location === "NGN" || location === "GHS") && (
                    <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                        <div>
                        <img src={transactionTypeIcon} alt='transactionTypeIcon' />
                        </div>
                        <div>
                        <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Account Type</h6>
                        <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                            {accountType || 'Not Selected'}
                        </p>
                        </div>
                    </div>
                    )}

                        <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <img src={transactionTypeIcon} alt='transactionTypeIcon' />
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Transfer Type</h6>
                                <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                                   {location !== "USD" ? "To Bank": 'To Address'}</p>
                            </div>
                        </div>

                           {/* Bank/Account Info */}
                            <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <img src={bank_icon} alt='bank_icon' />
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>
                                {location !== "USD" ? "Bank" : "Account Info"}
                                </h6>
                                <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                                {bankName || 'Not Selected'}
                                </p>
                            </div>
                            </div>

                        {location !== "USD" && 
                         <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <img src={bank_icon} alt='bank_icon' />
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Account Number</h6>
                                <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>{accountNumber ? accountNumber: ''}</p>
                            </div>
                        </div>
                        }

                         {/* Account Name - Show for NGN and GHS */}
                        {location !== "USD" && (
                        <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                            <img src={bank_icon} alt='bank_icon' />
                            </div>
                            <div>
                            <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Account Name</h6>
                            <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                                {accountName || 'Not Available'}
                            </p>
                            </div>
                        </div>
                        )}

                        <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <img src={narration_icon} alt='narration_icon' />
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Narration</h6>
                                <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>{narration ? narration: 'N/A'}</p>
                            </div>
                        </div>


                        <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <img src={moneyIcon} alt='moneyIcon' />
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Amount</h6>
                                <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>{location} {amount}</p>
                            </div>
                        </div>

                        <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                            <div>
                                <img src={moneyIcon} alt='moneyIcon' />
                            </div>
                            <div>
                                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Withdrawal fee</h6>
                                <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>{location} {``}
                                    {
                                        location === "NGN" 
                                        ?
                                        fees && fees.naira_withdrawal_fee ? fees?.naira_withdrawal_fee?.value?.data: 0
                                        :
                                        fees && fees.ghana_withdrawal_fee ? fees?.ghana_withdrawal_fee?.value?.data: 0
                                    }
                                </p>
                            </div>
                        </div>

                    </div>
                    
                    <button onClick={handleTransferToBank} style={{marginTop: '30px'}} className={style.save}>
                    Proceed
                    </button>

                </div>
                }
         </Modal>

         {/* =========================== THE LOADING MODAL FOR PROCESSING WITHDRAWAL REQUEST  */}
         <Modal
        canClose={false}
        modalOpen={isOpen}
        setModalOpen={setIsOpen}
      >
        <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={spin_circle} alt="spin circle" className={style.animate_spin} />
            </div>

            <div>
                <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>Initiating Withdrawal</h4>
             
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                  Please wait...
                </p>
               
            </div>
        </div>

        </Modal>

        {/* ======== THE MODAL TO STATE THAT TRANSFER IS SUCCCESSFUL */}
        <Modal
        canClose={true}
        modalOpen={isSuccessModal}
        setModalOpen={setSuccessModal}
      >
        <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={successIcon} alt="spin circle" />
            </div>

            <div>
                <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>Withdrawal Successful</h4>
            
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                    Your withdrawal request has been successfully processed.
                </p>
            </div>

            <button onClick={() => setSuccessModal(false)} style={{marginTop: '20px'}} className={style.save}>
               Continue
            </button>

        </div>

        </Modal>

         {/* MODAL FOR TRANSACTION PIN */}
        <Modal canClose={true} modalOpen={putPass} setModalOpen={setPutPass}>
          <div className={style.setTrPin}>
            <h2 className={style.pinHead}>Transaction Pin</h2>
            <p>Please input your transaction pin</p>
            <div className={style.inputs2}>
              <PinInput
                length={5}
                initialValue=""
                secret={true}
                ref={(n) => {
                  ele = n;
                }}
                onChange={(value, index) => {
                  setTrPin(value);
                }}
                type="numeric"
                inputMode="number"
                style={{ padding: "10px", margin: "0 auto 0 auto" }}
                inputStyle={{ border: "1px solid", borderColor: "#909090" }}
                inputFocusStyle={{
                  border: "2px solid",
                  borderColor: "#40196D",
                }}
                onComplete={(value, index) => {
                  setTrPin(value);
                }}
                autoSelect={true}
                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
              />
            </div>
            <button
              disabled={disabled}
              onClick={withdrawHandler}
              className={style.save}
            >
              Withdraw Funds
            </button>
          </div>
        
      </Modal>

         {/* MODAL FOR ASTRO TAG TRANSACTION PIN */}
         <Modal canClose={true} modalOpen={isTagPinModal} setModalOpen={setTagPinModal}>
          <div className={style.setTrPin}>
            <h2 className={style.pinHead}>Transaction Pin</h2>
            <p>Please input your transaction pin</p>
            <div className={style.inputs2}>
              <PinInput
                length={5}
                initialValue=""
                secret={true}
                ref={(n) => {
                  ele = n;
                }}
                onChange={(value, index) => {
                  setTrPin(value);
                }}
                type="numeric"
                inputMode="number"
                style={{ padding: "10px", margin: "0 auto 0 auto" }}
                inputStyle={{ border: "1px solid", borderColor: "#909090" }}
                inputFocusStyle={{
                  border: "2px solid",
                  borderColor: "#40196D",
                }}
                onComplete={(value, index) => {
                  setTrPin(value);
                }}
                autoSelect={true}
                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
              />
            </div>
            <button
              disabled={disabled}
              className={style.save}
              onClick={handleInitiateTransfer}
            >
              Initiate Transfer
            </button>
          </div>
        
      </Modal>

        <div
            className={style.cashTabs}
        >
            <ul>
            {walletData?.fiatWallets?.map((wallet) => {
                const code = wallet.Currency.code;
                const icon = currencyIcons[code];
                const isSelected = location === code;

                return (
                <li
                    key={wallet.id}
                    onClick={() => handleTabChange(code)}
                    style={{
                    borderBottom: isSelected
                        ? "3px #40196D solid"
                        : "0px #90909039 solid",
                    }}
                >
                    <div>
                    <img
                        src={icon}
                        alt={`${code.toLowerCase()} icon`}
                        style={{
                        width: "22px",
                        height: "22px",
                        borderRadius: "50%",
                        opacity: isSelected ? "100%" : "60%",
                        }}
                    />
                    <p
                        style={{
                        color: isSelected ? "#40196D" : "#C1C1C1",
                        }}
                    >
                        {code} WALLET
                    </p>
                    </div>
                </li>
                );
                  })}
            </ul>


        </div>

        {/* ------ NGN WALLET SECTION */}
       {
        location === "NGN" && (
        <div className={style.walletDiv}>
            <div className={style.walletCard}>

                <div>
                    <p className={style.walletTitle}>
                    {walletData.fiatWallets && walletData.fiatWallets.length
                        ? "WALLET BALANCE"
                        : "ADD A WALLET "}
                    </p>

                    {walletData.fiatWallets && walletData.fiatWallets.length ? (
                     <div className={style.balance}>
                        <p>
                        {visible === true
                            ? `${
                                walletData.fiatWallets
                                ? (
                                    walletData.fiatWallets[0]
                                        ? parseFloat(walletData.fiatWallets[0].balance).toLocaleString()
                                        : ""
                                    )
                                : "0.000"
                            }`
                            : "XXXXXXXXX"}
                        </p>
                        {visible === true ? (
                        <EyeSlash
                            onClick={() => {
                            setVisible(!visible);
                            }}
                            className={style.walEye}
                            color="#fff"
                            variant="Bulk"
                            style={{cursor: 'pointer'}}
                        />
                        ) : (
                        <Eye
                            onClick={() => {
                            setVisible(!visible);
                            }}
                            className={style.walEye}
                            color="#fff"
                            variant="Bulk"
                            style={{cursor: 'pointer'}}

                        />
                        )}
                     </div>
                     ) : (
                        <p style={{marginTop: '8px', color: '#fff'}} className={style.walletTitle}>You have no wallets</p>
                     )}
                </div>

               
                 {walletData.fiatWallets && walletData.fiatWallets.length ? (
                    <div className={style.countryDiv}>
                    <img src={ng_icon} alt="nigeria icon" 
                    />
                    <p className={style.currencyText}>NGN</p>
                  </div>  
                 ) : "" }

                <div className={style.walletArrowBg}>
                    <img src={walletArrowBg} alt="wallet arrow" />
                </div>   
            </div>

            <div onClick={toggleAstroBankTransfer}  className={style.directBankDiv}>
                <div>
                    <h6 className={style.title}>AstroTag</h6>
                    <p className={style.subtitle}>Receive money and send money to another Astrotag user for free.</p>
                
                </div>
                <div className={style.ctaDiv} style={{cursor: 'pointer'}}>
                    <img src={arrow_right} alt='arrow right' />
                </div>
            </div>

            <div onClick={toggleBankTransfer} className={style.cyptoBankDiv}>
                <div>
                    <h6 className={style.title}>To Bank</h6>
                    <p className={style.subtitle}>
                    Send money to your saved accounts 
                    </p>
                </div>
                <div className={style.ctaDiv}>
                    <img src={arrow_right} alt='arrow right' />
                </div>
            </div>
        </div>
        )}

        {/* --- GHS WALLET SECTION */}
        {
        location === "GHS" && (
        <div className={style.walletDiv}>
            <div className={style.walletCard}>

                <div>
                    <p className={style.walletTitle}>
                    {walletData.fiatWallets && walletData.fiatWallets.length
                        ? "WALLET BALANCE"
                        : "ADD A WALLET "}
                    </p>
                    {walletData.fiatWallets && walletData.fiatWallets.length ? (
                    <div className={style.balance}>
                        <p>
                        {visible === true
                            ? `${
                                walletData.fiatWallets
                                ? (
                                    walletData.fiatWallets[1]
                                        ? parseFloat(walletData.fiatWallets[1].balance).toLocaleString()
                                        : "0.00"
                                    )
                                : "0.00"
                            }`
                            : "XXXXXXXXX"}
                        </p>
                        {visible === true ? (
                        <EyeSlash
                            onClick={() => {
                            setVisible(!visible);
                            }}
                            className={style.walEye}
                            color="#fff"
                            variant="Bulk"
                            style={{cursor: 'pointer'}}
                        />
                        ) : (
                        <Eye
                            onClick={() => {
                            setVisible(!visible);
                            }}
                            className={style.walEye}
                            color="#fff"
                            variant="Bulk"
                            style={{cursor: 'pointer'}}

                        />
                        )}
                     </div>
                    ) : (
                        <p style={{marginTop: '8px', color: '#fff'}} className={style.walletTitle}>You have no wallets</p>
                     )}
                </div>

                {walletData.fiatWallets && walletData.fiatWallets.length ? (
                <div className={style.countryDiv}>
                    <img src={ghana_icon} alt="ghana icon" 
                    />
                    <p className={style.currencyText}>GHS</p>
                </div>  
                 ) : "" }

                <div className={style.walletArrowBg}>
                    <img src={walletArrowBg} alt="wallet arrow" />
                </div>   
            </div>

            <div onClick={toggleAstroBankTransfer} className={style.directBankDiv}>
                <div>
                <h6 className={style.title}>AstroTag</h6>
                <p className={style.subtitle}>Receive money and send money to another Astrotag user for free.</p>

                 
                </div>
                <div className={style.ctaDiv}>
                    <img src={arrow_right} alt='arrow right' />
                </div>
            </div>

            <div  onClick={toggleBankTransfer} className={style.cyptoBankDiv}>
                <div>
                    <h6 className={style.title}>To Bank</h6>
                    <p className={style.subtitle}>
                    Send money to your saved accounts.
                    </p>
                </div>
                <div className={style.ctaDiv}>
                    <img src={arrow_right} alt='arrow right' />
                </div>
            </div>
        </div>
         )}

         {/* --- USD WALLET SECTION */}
         {
        location === "USD" && (
        <div className={style.walletDiv}>
            <div className={style.walletCard}>

                <div>
                  <p className={style.walletTitle}>
                    {walletData.fiatWallets && walletData.fiatWallets.length
                        ? "WALLET BALANCE"
                        : "ADD A WALLET "}
                    </p>
                    {walletData.fiatWallets && walletData.fiatWallets.length ? (
                    <div className={style.balance}>
                        <p>
                        {visible === true
                            ? `${
                                walletData.fiatWallets
                                ? (
                                    walletData.fiatWallets[2]
                                        ? parseFloat(walletData.fiatWallets[2].balance).toLocaleString()
                                        : "0.00"
                                    )
                                : "0.00"
                            }`
                            : "XXXXXXXXX"}
                        </p>
                        {visible === true ? (
                        <EyeSlash
                            onClick={() => {
                            setVisible(!visible);
                            }}
                            className={style.walEye}
                            color="#fff"
                            variant="Bulk"
                            style={{cursor: 'pointer'}}
                        />
                        ) : (
                        <Eye
                            onClick={() => {
                            setVisible(!visible);
                            }}
                            className={style.walEye}
                            color="#fff"
                            variant="Bulk"
                            style={{cursor: 'pointer'}}

                        />
                        )}
                     </div>
                       ) : (
                        <p style={{marginTop: '8px', color: '#fff'}} className={style.walletTitle}>You have no wallets</p>
                     )}
                </div>
            
                {walletData.fiatWallets && walletData.fiatWallets.length ? (
                <div className={style.countryDiv}>
                    <img src={usd_icon} alt="usd icon" 
                    style={{ width: "24px", height: '24px', borderRadius: '50%' }}
                    />
                    <p className={style.currencyText}>USD</p>
                </div>  
                  ) : "" }

                <div className={style.walletArrowBg}>
                    <img src={walletArrowBg} alt="wallet arrow" />
                </div>   
            </div>

            <div onClick={toggleAstroBankTransfer} className={style.directBankDiv}>
                <div>
                <h6 className={style.title}>AstroTag</h6>
                <p className={style.subtitle}>Receive money and send money to another Astrotag user for free.</p>

                 
                </div>
                <div className={style.ctaDiv}>
                <img src={arrow_right} alt='arrow right' />
                </div>
            </div>

            <div onClick={toggleBankTransfer} className={style.cyptoBankDiv}>
                <div>
                <h6 className={style.title}>To Bank</h6>
                <p className={style.subtitle}>
                Send money to your saved accounts.
                </p>
                </div>
                <div className={style.ctaDiv}>
                    <img src={arrow_right} alt='arrow right' />
                </div>
            </div>
        </div>
         )}     
        </>
     );
}
 
export default WithdrawWithFiatPage;